import { useSelector } from 'react-redux';

import { CampaignType } from '@dev/ee-api/ee-api-models';
import { isEmpty } from 'lodash-es';

import dayjs from '@/services/tools/dayjs';
import { getTimeInUnits } from '@/services/tools/getTimeInUnits';
import { TimeUnitsEnum } from '@/services/dictionaries/TimeUnits';
import { getCampainCreatorStore } from '@/store/campaignCreator/actions';

export const useGetAutoresponderScheduledInfo = () => {
    const { isLoading, isNew, campaign } = useSelector(getCampainCreatorStore);

    const isDataLoaded = !isLoading && !isEmpty(campaign);
    const isEdit = isDataLoaded && !isNew;
    const isAutomatedEdit = isDataLoaded && campaign.Type === CampaignType.Automated && !isNew;
    const timeObj = getTimeInUnits(campaign.TriggerOptions?.SendAfterXMinutes) || null;

    const isImmediately = isAutomatedEdit && campaign.TriggerOptions?.SendAfterXMinutes > 0 ? false : true;
    const triggerValue = isAutomatedEdit ? timeObj.value : 1;
    const triggerUnit = isAutomatedEdit ? timeObj.unit : TimeUnitsEnum.Days;
    const dateToSend = campaign.TriggerOptions.DateToSendOn;

    const sendAfterTime = isEdit
        ? dateToSend
            ? dayjs(dateToSend).utc(true).local()
            : dayjs().add(1, 'hour')
        : dayjs().add(1, 'hour');

    return { isImmediately, sendAfterTime, triggerValue, triggerUnit };
};
